import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "mileage", "mileageWrapper", "mileageWarning",
        "usageHours", "usageHoursWrapper", "usageHoursWarning",
        "newContactPersonButton"
    ]
    static values = {
        recordedMileage: Number,
        recordedUsageHours: Number,
        usesOperatingHours: Boolean
    }

    connect() {
        this.clientField = this.element.querySelector(
            '[data-autocomplete-field-key-value="client_id"]'
        )

        this.clientChangedHandler = this.clientChanged.bind(this)
        this.vehicleChangedHandler = this.vehicleChanged.bind(this)

        if (this.clientField) {
            this.clientField.addEventListener("autocomplete:changed", this.clientChangedHandler)
        }

        this.updateNewContactPersonButton(this.selectedClientId())

        this.vehicleField = this.element.querySelector(
            '[data-autocomplete-field-key-value="vehicle_id"]'
        )

        if (this.vehicleField) {
            this.vehicleField.addEventListener("autocomplete:changed", this.vehicleChangedHandler)
        }

        this.setMeterMode(this.usesOperatingHoursValue)
        this.checkMileage()
        this.checkUsageHours()
    }

    disconnect() {
        if (this.clientField && this.clientChangedHandler) {
            this.clientField.removeEventListener("autocomplete:changed", this.clientChangedHandler)
        }

        if (this.vehicleField && this.vehicleChangedHandler) {
            this.vehicleField.removeEventListener("autocomplete:changed", this.vehicleChangedHandler)
        }
    }

    clientChanged(event) {
        this.updateNewContactPersonButton(event.detail?.value)
        this.recordedMileageValue = 0
        this.recordedUsageHoursValue = 0
        this.setMileageValue(0)
        this.setUsageHoursValue(0)
    }

    vehicleChanged(event) {
        const rawMileage = event.detail?.meta?.mileage_km
        const mileage = Number(rawMileage)
        const hasMileage = rawMileage !== undefined &&
            rawMileage !== null &&
            rawMileage !== "" &&
            Number.isFinite(mileage)
        const rawUsageHours = event.detail?.meta?.usage_hours
        const usageHours = Number(rawUsageHours)
        const hasUsageHours = rawUsageHours !== undefined &&
            rawUsageHours !== null &&
            rawUsageHours !== "" &&
            Number.isFinite(usageHours)
        const usesOperatingHours = event.detail?.meta?.uses_operating_hours === true ||
            event.detail?.meta?.uses_operating_hours === "true"

        this.recordedMileageValue = hasMileage ? mileage : 0
        this.recordedUsageHoursValue = hasUsageHours ? usageHours : 0
        this.usesOperatingHoursValue = usesOperatingHours
        this.setMileageValue(this.recordedMileageValue)
        this.setUsageHoursValue(this.recordedUsageHoursValue)
        this.setMeterMode(usesOperatingHours)
        this.checkMileage()
        this.checkUsageHours()
    }

    setUsageHoursValue(hours) {
        if (!this.hasUsageHoursTarget) return

        this.usageHoursTarget.value = String(hours)
    }

    setMeterMode(usesOperatingHours) {
        this.mileageWrapperTarget?.classList.toggle("d-none", usesOperatingHours)
        this.usageHoursWrapperTarget?.classList.toggle("d-none", !usesOperatingHours)
        if (this.hasMileageTarget) this.mileageTarget.disabled = usesOperatingHours
        if (this.hasUsageHoursTarget) this.usageHoursTarget.disabled = !usesOperatingHours
    }

    setMileageValue(mileage) {
        if (!this.hasMileageTarget) return

        this.mileageTarget.value = String(mileage)
    }

    selectedClientId() {
        return this.clientField?.querySelector('[data-autocomplete-target="hidden"]')?.value
    }

    updateNewContactPersonButton(clientId) {
        if (!this.hasNewContactPersonButtonTarget) return

        const button = this.newContactPersonButtonTarget
        const url = new URL(button.dataset.baseUrl, window.location.origin)
        const hasClient = Boolean(clientId)

        if (hasClient) url.searchParams.set("client_id", clientId)

        button.disabled = !hasClient
        button.dataset.url = `${url.pathname}${url.search}`
    }

    checkMileage() {
        if (!this.hasMileageTarget || !this.hasMileageWarningTarget) return

        const mileage = Number(this.mileageTarget.value)
        const isLower = this.mileageTarget.value !== "" &&
            Number.isFinite(mileage) &&
            mileage < this.recordedMileageValue

        this.mileageTarget.classList.toggle("border-danger", isLower)
        this.mileageTarget.classList.toggle("text-danger", isLower)
        this.mileageWarningTarget.classList.toggle("d-none", !isLower)
    }

    checkUsageHours() {
        if (!this.hasUsageHoursTarget || !this.hasUsageHoursWarningTarget) return

        const usageHours = Number(this.usageHoursTarget.value)
        const isLower = this.usageHoursTarget.value !== "" &&
            Number.isFinite(usageHours) &&
            usageHours < this.recordedUsageHoursValue

        this.usageHoursTarget.classList.toggle("border-danger", isLower)
        this.usageHoursTarget.classList.toggle("text-danger", isLower)
        this.usageHoursWarningTarget.classList.toggle("d-none", !isLower)
    }
}
